module.exports = __webpack_public_path__ + "assets/74fe40c5df41a0627913829a322cdc0a.jpg";